import React, { ComponentType } from "react"
import { compose } from "@reduxjs/toolkit"
import { Link } from "react-router-dom"
import { Box, List, ListItem, Typography, styled } from "@mui/material"

import { withClientManager } from "hocs/features"
import { ClientManagerType } from "types"

type Props = {
  manager: ClientManagerType
}

const ClientManagerComponent = ({ manager }: Props) => {
  return (
    <Container data-testid="client-manager">
      <List>
        <Item>
          <Typography>{manager.full_name}</Typography>
        </Item>
        <Item>
          <ItemLink to={`mailto:${manager.email}`}>{manager.email}</ItemLink>
        </Item>
        <Item>{manager.phone}</Item>
      </List>
    </Container>
  )
}

export default compose<ComponentType>(withClientManager)(ClientManagerComponent)

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
`

const Item = styled(ListItem)`
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
  opacity: 0.5;
  padding: 5px 9px;
  width: 100%;
`

const ItemLink = styled(Link)`
  color: ${({ theme }) => theme.palette.common.white};
`
